import React from 'react'
import { Link } from 'react-router-dom'
import { DocPage, Mail, Section } from './doc-kit'
import { ENTRA_SSO_PATH } from './doc-entra-sso'
import { SCIM_PATH } from './doc-scim-provisioning'

// /public/docs: the list of public integration guides.

export const GUIDES = [
  {
    to: ENTRA_SSO_PATH,
    title: 'Single sign-on with Microsoft Entra ID',
    text: 'Approve the EducationXR app in your tenant, choose who can sign in, map groups to roles and connect your email domain. OpenID Connect.'
  },
  {
    to: SCIM_PATH,
    title: 'User provisioning (SCIM 2.0)',
    text: 'Let Microsoft Entra ID or Okta add, update and remove your people and groups in EducationXR. OAuth 2.0 client credentials or a Bearer token.'
  }
]

export const DocsIndex = () => (
  <DocPage
    title="Integration guides"
    lead="Set-up guides for IT administrators who connect their organization's identity provider to EducationXR."
    toc={false}
  >
    <ul className="doc-cards">
      {GUIDES.map(g => (
        <li key={g.to}>
          <Link className="doc-card" to={g.to}>
            <span className="doc-card-title">{g.title}</span>
            <span className="doc-card-text">{g.text}</span>
            <span className="doc-card-more">Read the guide →</span>
          </Link>
        </li>
      ))}
    </ul>

    <Section id="support" title="Support">
      <p>
        Questions about single sign-on or provisioning: email <Mail />.
      </p>
    </Section>
  </DocPage>
)
